import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useShop } from "../context/ShopContext";
import { WHATSAPP_NUMBER } from "../i18n";

const WhatsAppFloat = () => {
  const { t, contacts } = useShop();
  const number = (contacts || []).find((c) => c.type === "whatsapp")?.value || WHATSAPP_NUMBER;
  const href = `https://wa.me/${number.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(
    t.whatsapp.float === "WhatsApp ile Sipariş"
      ? "Merhaba! VLP Dolap ürünleri hakkında bilgi almak istiyorum."
      : "Hello! I'd like to learn more about VLP Dolap products."
  )}`;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2.2, duration: 0.5, type: "spring", bounce: 0.4 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#4F5D3A] text-cream flex items-center justify-center shadow-[0_8px_30px_rgba(90,56,30,0.35)]"
      aria-label={t.whatsapp.float}
      data-testid="whatsapp-float-button"
    >
      <MessageCircle size={24} strokeWidth={1.75} />
      <span className="absolute inset-0 rounded-full bg-[#4F5D3A] animate-ping opacity-20" />
    </motion.a>
  );
};

export default WhatsAppFloat;
